<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
      <h2 class="headline m-0" fxFlex="auto">
        {{heading}}
      </h2>
      <div mat-dialog-close>
        <button type="button" (click)="onClose(dialogRef)" mat-icon-button class="text-secondary">
            <mat-icon [icIcon]="icClose"></mat-icon>
          </button>
      </div>
    </div>
  
    <mat-divider class="-mx-6 text-border"></mat-divider>
    <div fxLayout="column" [ngStyle]="{'height': getHeight(190)}">
    <div class="mt-3 overflow-y-auto">
      <p *ngIf="isHtmlContent(content)" [innerHTML]="content"></p>
      <p *ngIf="!isHtmlContent(content)">{{content}}</p> 
    </div>
    </div>
     <mat-divider class="-mx-6 text-border"></mat-divider>
      <div fxLayout="row" class="mt-5" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button (click)="onClose(dialogRef)" mat-button mat-dialog-close color="primary" mat-raised-button>Got it</button>
      </div>
</div>